export const PRIVATE_TASK_MODULE = 'privateTask';
